import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';
import { StyledList, StyledItem } from './RadioButtonList.style';

export default class RadioButtonList extends PureComponent {
  render() {
    const { options, styled, renderButton, className, value, onChange } = this.props;

    return (
      <StyledList className={className}>
        {options.map((option) => (
            <StyledItem
              key={option.id}
              data-testid="radio-button-item"
            >
              <RadioButton
                option={option}
                value={value}
                styled={styled}
                onChange={onChange}
              />
              {renderButton(option)}
            </StyledItem>
        ))}
      </StyledList>
    );
  }
}

RadioButtonList.displayName = 'RadioButtonList';
RadioButtonList.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};
